import { useEffect, useState } from 'react';
import { formattingNumber } from 'utils';
import { StyledBundlePrice } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { Box } from '@mui/material';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

const WhispersBundlePrice: React.FC<PMBundlePriceProps> = ({
  price,
  isPreview = false,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
}) => {
  const [finalPrice, setFinalPrice] = useState('');
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    if (price.strokedPriceInCents) {
      const formattedPriceBeforeDiscount = formattingNumber(
        price?.strokedPriceInCents,
        price,
        price.isCents,
        price.multiplier,
        !isPreview,
      );
      setPriceBeforeDiscount(formattedPriceBeforeDiscount);
    }
    setFinalPrice(formattedPrice);
  }, [price]);

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    setFinalPrice(formattedPrice);
  }, [price, isPreview]);

  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
    >
      <div className="whispers__price-button totalPrice">
        {priceBeforeDiscount && (
          <AutoTextSize
            maxFontSizePx={14}
            minFontSizePx={6}
            as="div"
            mode="oneline"
          >
            <Box
              className="stroked has-stroked"
              gap={price.spacing ? '4px' : '0'}
            >
              <span>{price.currencySymbol}</span>
              <span className="actual-price">{priceBeforeDiscount}</span>
            </Box>
          </AutoTextSize>
        )}
        <AutoTextSize
          maxFontSizePx={16}
          minFontSizePx={8}
          as="div"
          mode="oneline"
          className={priceBeforeDiscount ? 'has-stroked' : ''}
        >
          <Box className="final-price" gap={price.spacing ? '4px' : '0'}>
            <span>{price.currencySymbol}</span>
            <span className="actual-price">{finalPrice}</span>
          </Box>
        </AutoTextSize>
      </div>
    </StyledBundlePrice>
  );
};

export default WhispersBundlePrice;
